import { STORE } from "../../enums/store";
import JobService from '../../services/jobService';
export default {
    LOAD_JOB_STATUSES({ commit }, utils) {
        const jobService = new JobService(utils);
        jobService.getJobStatuses().then(resp => {
            commit(`${STORE.JOBTRACKER}/SET_JOB_STATUSES`, resp, { root: true });
        });    
    },
}